export interface ArticleDetail {
  id: string;
  title: string;
  subtitle: string;
  category: string;
  categorySlug: string;
  author: string;
  authorAvatar: string;
  date: string;
  readTime: string;
  coverImage: string;
  content: ArticleSection[];
  tags: string[];
  relatedIds: string[];
}

export interface ArticleSection {
  type: 'paragraph' | 'heading' | 'image' | 'quote';
  content: string;
  caption?: string;
}

export const articleDetails: Record<string, ArticleDetail> = {
  'bts-2026-comeback': {
    id: 'bts-2026-comeback',
    title: 'BTS 2026 完整体回归！新专辑《WINGS OF DAWN》全球同步上线',
    subtitle: '时隔两年完整体回归，融合电子与古典元素，首日打破多项纪录',
    category: '音乐',
    categorySlug: 'music',
    author: '韩流观察员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Asian%20woman%20with%20warm%20smile%2C%20clean%20studio%20portrait%2C%20soft%20lighting%2C%20professional%20yet%20friendly%20look%2C%20simple%20neutral%20background&width=80&height=80&seq=avatar-01&orientation=squarish',
    date: '2026-08-08',
    readTime: '8分钟',
    coverImage: 'https://readdy.ai/api/search-image?query=Kpop%20boy%20band%20artistic%20concept%20photo%20with%20golden%20and%20coral%20lighting%2C%20dramatic%20silhouettes%2C%20cinematic%20stage%20atmosphere%2C%20grand%20scale%2C%20professional%20music%20photography&width=1200&height=600&seq=article-bts&orientation=landscape',
    content: [
      { type: 'paragraph', content: '2026年8月8日，对于全球ARMY来说是一个值得铭记的日子。时隔整整两年，韩国顶级男团BTS以完整体形式重磅回归，携全新专辑《WINGS OF DAWN》正式与全球粉丝见面。' },
      { type: 'paragraph', content: '新专辑《WINGS OF DAWN》（黎明的翅膀）收录了包括主打歌《First Light》在内的12首全新曲目，专辑概念围绕"重生与希望"展开，融合了电子音乐与古典交响乐的创新尝试，展现了七位成员在军旅生涯后更加成熟的艺术表达。' },
      { type: 'heading', content: '专辑概念与音乐风格' },
      { type: 'paragraph', content: '《WINGS OF DAWN》的整体概念源于希腊神话中的曙光女神厄俄斯（Eos），象征着黑暗之后的黎明与新生。专辑视觉采用了大量金色与珊瑚色渐变元素，与专辑名称完美呼应。音乐风格上，这张专辑展现了BTS前所未有的多样性——从主打歌《First Light》气势磅礴的电子交响融合，到《Moonlit Path》的R&B抒情，再到《Echo Chamber》的实验性电子，每一首歌曲都展现了成员们在音乐上的成长与探索。' },
      { type: 'paragraph', content: '特别值得一提的是，成员SUGA和RM深度参与了整张专辑的制作与词曲创作，队长RM更是担任了执行制作人的角色。他在专辑发布会上表示："这张专辑是我们在休整期后，对音乐、对人生、对与粉丝关系的重新思考。我们希望用音乐传达——即使经历了漫长的黑夜，黎明终将到来。"' },
      { type: 'image', content: 'https://readdy.ai/api/search-image?query=Kpop%20album%20concept%20art%20with%20abstract%20golden%20wings%20and%20dawn%20sky%2C%20ethereal%20atmosphere%2C%20artistic%20design%2C%20warm%20coral%20and%20golden%20gradient%2C%20clean%20minimalist%20composition&width=1000&height=500&seq=article-bts-2&orientation=landscape', caption: '《WINGS OF DAWN》专辑概念视觉图' },
      { type: 'heading', content: '首日成绩刷新纪录' },
      { type: 'paragraph', content: '专辑上线首日便创下惊人成绩：主打歌《First Light》MV在YouTube上线仅3小时便突破1亿次观看，刷新了平台最快破亿纪录；专辑在Spotify全球首日流媒播放量达到8900万次，登顶全球榜首位；Hanteo首日销量突破420万张，再次证明了BTS无可撼动的全球影响力。' },
      { type: 'quote', content: '"我们终于回来了。这两年的等待对ARMY和我们来说都不容易，但正是这份等待让今天的重逢更加珍贵。感谢你们的耐心和不变的爱。"——BTS在回归直播中的感言' },
      { type: 'heading', content: '全球宣传活动计划' },
      { type: 'paragraph', content: '据悉，BTS将在接下来的两个月内展开密集的全球宣传活动。韩国首站宣传活动将于8月15日在首尔奥林匹克主竞技场举办，此后将陆续前往东京、洛杉矶、伦敦、巴黎等全球主要城市。成员们还确认将出演多个国际知名脱口秀节目，包括《The Tonight Show》和《The Late Show》。' },
      { type: 'paragraph', content: '此外，HYBE官方还透露，BTS的全球巡演计划正在筹备中，预计将于2027年上半年正式启动，届时将涵盖亚洲、北美、欧洲和南美等多个地区的超过30个城市。这无疑将成为全球音乐市场的又一次盛事。' },
    ],
    tags: ['BTS', 'K-POP', '回归', 'WINGS OF DAWN', '防弹少年团'],
    relatedIds: ['twice-world-tour-seoul', 'newjeans-tokyo-dome', 'seventeen-follow-tour'],
  },
  'japan-anime-summer-2026': {
    id: 'japan-anime-summer-2026',
    title: '2026夏番日漫推荐：十部必追新番，京都动画新作领衔',
    subtitle: '从热血战斗到治愈日常，精选十部不可错过的夏季新番',
    category: '影视',
    categorySlug: 'drama',
    author: '动漫编辑室',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Asian%20man%20with%20glasses%2C%20friendly%20expression%2C%20clean%20studio%20portrait%2C%20soft%20lighting%2C%20creative%20professional%20look%2C%20simple%20background&width=80&height=80&seq=avatar-02&orientation=squarish',
    date: '2026-08-07',
    readTime: '12分钟',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20summer%20scenery%20illustration%20with%20beautiful%20sky%20and%20cherry%20blossoms%2C%20vibrant%20colors%2C%20warm%20sunlight%2C%20anime%20art%20style%2C%20cinematic%20composition%2C%20dreamy%20atmosphere&width=1200&height=600&seq=article-anime&orientation=landscape',
    content: [
      { type: 'paragraph', content: '2026年的夏季新番季堪称近年来最强阵容！从京都动画时隔三年的回归之作，到MAPPA、WIT STUDIO等顶级动画工作室的最新力作，这个夏天注定让动漫迷们目不暇接。以下是我们为你精选的十部必追新番。' },
      { type: 'heading', content: '京都动画回归：《青空的旋律》' },
      { type: 'paragraph', content: '毫无疑问，本季最受瞩目的作品当属京都动画的《青空的旋律》。这是京都动画继《弦音 -风舞高中弓道部-》之后，时隔三年推出的全新原创动画。作品以音乐与青春为主题，讲述了一群高中生在吹奏乐部的成长故事。' },
      { type: 'paragraph', content: '从已经公开的前三话来看，《青空的旋律》延续了京都动画一贯的精美作画和对人物情感的细腻刻画。音乐部分由知名作曲家牛尾宪辅操刀，与画面完美融合，堪称视听双重享受。' },
      { type: 'heading', content: '热血战斗：《咒术回战 第三季》' },
      { type: 'paragraph', content: 'MAPPA制作的《咒术回战》第三季终于来了！本季将改编"死灭回游"篇的剧情，虎杖悠仁与伏黑惠将面对前所未有的强敌。MAPPA的动作场面制作水准在本季再创新高，每一场战斗都堪称视觉盛宴。' },
    ],
    tags: ['日漫', '新番', '京都动画', '咒术回战', '2026夏番'],
    relatedIds: ['ghibli-new-film', 'squid-game-3', 'j-drama-first-love-2'],
  },
  'k-variety-earth-arcade-3': {
    id: 'k-variety-earth-arcade-3',
    title: '《地球游乐厅3》重磅回归！原班人马再聚首，笑点密集升级',
    subtitle: '罗英锡PD现象级综艺第三季，李恩智、MIMI、李泳知、安宥真全员回归',
    category: '综艺',
    categorySlug: 'variety',
    author: '综艺情报局',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Asian%20person%20with%20bright%20smile%2C%20casual%20professional%20look%2C%20clean%20studio%20portrait%2C%20soft%20lighting%2C%20friendly%20expression%2C%20simple%20background&width=80&height=80&seq=avatar-03&orientation=squarish',
    date: '2026-08-06',
    readTime: '6分钟',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20variety%20show%20tropical%20outdoor%20setting%20with%20colorful%20decorations%2C%20playful%20atmosphere%2C%20bright%20sunny%20day%2C%20entertainment%20production%2C%20warm%20vibrant%20colors%2C%20fun%20vacation%20vibe&width=1200&height=600&seq=article-variety&orientation=landscape',
    content: [
      { type: 'paragraph', content: '罗英锡PD打造的韩国TVING原创综艺《地球游乐厅》第三季于8月6日正式首播！这档以"为了抓住逃到地球的月球兔子而聚集在一起的勇士们，无法预测的大混乱旅游综艺"为概念的节目，在前两季收获了极高的人气和口碑，第三季的回归更是备受期待。' },
      { type: 'heading', content: '原班人马，默契升级' },
      { type: 'paragraph', content: '最令粉丝欣喜的是，第三季实现了原班人马的全员回归——李恩智、MIMI（OH MY GIRL）、李泳知、安宥真（IVE）四位勇士再度集结。经过前两季的磨合，四位成员之间的化学反应更加自然和爆笑。' },
      { type: 'heading', content: '首站泰国，笑料不断' },
      { type: 'paragraph', content: '第三季首期选择在泰国进行录制，四位勇士在异国他乡展开了一系列令人捧腹的游戏和任务。从曼谷街头的美食挑战到清迈丛林的勇气考验，每一帧画面都充满了欢乐和惊喜。' },
      { type: 'quote', content: '"这一季我们准备了更多疯狂的游戏和意想不到的规则。看着四位勇士的表现，我在监视器后面笑得停不下来。"——罗英锡PD' },
    ],
    tags: ['地球游乐厅', '罗英锡', '综艺', '李泳知', '安宥真'],
    relatedIds: ['running-man-700-episode', 'knowing-bros-500', 'i-live-alone-special'],
  },
};